<script>
import { Alert } from '../../services/alert';

export default {
  props: {
    formhashid: {
      type: String,
      required: true,
    },
  },

  data () {
    return {
      integration: {
        javascript: null,
      },
      modules: [],
      types: false,
      error: null,
      saving: false,
      clip: false,
    };
  },

  mounted () {
    this.loadIntegrationJS();

    setTimeout(() => {
      document.querySelector('#form.name').focus();
    }, 500);

    if (this.clip) {
      this.clip.destroy();
    }

    this.$nextTick(() => {
      this.clip = (new ClipboardJS(this.$refs['copy-js'])).on('success', () => {
        Alert.success(this.__('Link copiado!'));
      });
    });
  },

  methods: {
    loadIntegrationJS () {
      this.$http.get(`/form/integration/javascript?form=${this.formhashid}`)
        .then(({ data }) => {
          this.integration.javascript = data;
        })
        .catch((error) => {
          console.log('Não foi possivel encontrar o script de integração, erro: ');
          console.log(error);
        });
    },
  },
};
</script>

<template>
  <div class="form-builder-integration">
    <h5 class="form-builder-integration__title pb-20px sticky-top">
      {{ __('Integração Javascript') }}
    </h5><a
      class="copy-link ml-2"
      id="copy-js"
      href="#"
      title="Copiar"
      ref="copy-js"
      data-clipboard-target="#integration-js-code"
    >{{ __('Copiar código') }}</a>
    <div class="px-20px" />
    <div class="form-group">
      <textarea
        class="form-control"
        id="integration-js-code"
        rows="12"
        :value="integration.javascript"
        readonly="readonly"
        v-if="integration.javascript"
      /><i
        class="fa fa-circle-o-notch fa-spin"
        v-else
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '../../../sass/variables';

  .form-builder-integration {
    &__title {
      height: 40px;
      display: flex;
      font-size: .8rem;
      font-weight: 400;
      text-align: left;
      margin-top: 10px;
      line-height: 15px;
      color: #857a98;
      position: relative;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      font-family: $input-font-family;
    }
  }
</style>
